module.exports = __webpack_public_path__ + "assets/img/ic-intro-vip.c8ef3461.png";